import CustomizeQueueResults from './CustomizeQueueResults';

export default CustomizeQueueResults;
